import {createContext, useContext, useEffect, useRef} from 'react';
import {trackApplicationForm, untrackApplicationForm} from '../../../app/application-drafts';

/** Interactive previews must not register themselves as editable business forms. */
export const ApplicationDraftTrackingContext = createContext(true);

export function useApplicationFormDraft(form?: {dirty: boolean; values: unknown}) {
  const enabled = useContext(ApplicationDraftTrackingContext);
  const key = useRef(Symbol('application-form'));
  const registered = useRef(false);
  useEffect(() => {
    if (form && enabled) {trackApplicationForm(key.current, form.dirty); registered.current = true;}
    else if (registered.current) {untrackApplicationForm(key.current); registered.current = false;}
  }, [form?.dirty, form?.values, enabled]);
  useEffect(() => {
    const id = key.current;
    return () => {if (registered.current) untrackApplicationForm(id);};
  }, []);
}
